/**
 * Descrizione leggibile del Meeting, senza il blocco tecnico che Google Meet
 * aggiunge automaticamente alle notifiche e agli ICS. Il testo originale non
 * viene mai riscritto nell'email o nell'osservazione invito: questa funzione
 * agisce solo sulla proiezione operativa e sul render CRM.
 */
const GOOGLE_MEET_BOUNDARY = /^[-:~]+$/;

const GOOGLE_MEET_BOILERPLATE = [
  /^join with google meet\s*:?.*$/i,
  /^or dial\s*:?.*$/i,
  /^more phone numbers\s*:?.*$/i,
  /^learn more about meet(?: at)?\s*:?.*$/i,
  /^please do not edit this section\.?$/i,
];

function isGoogleMeetBoilerplate(line: string): boolean {
  const trimmed = line.trim();
  return (
    (trimmed.includes('~') && GOOGLE_MEET_BOUNDARY.test(trimmed)) ||
    GOOGLE_MEET_BOILERPLATE.some((pattern) => pattern.test(trimmed))
  );
}

/**
 * Restituisce solo il testo utile per lavorare; `null` quando la descrizione
 * contiene esclusivamente istruzioni tecniche gia' rappresentate da luogo e
 * link cliccabile del meeting.
 */
export function operationalMeetingDescription(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const lines = value
    .replace(/\r\n?/g, '\n')
    .split('\n')
    .filter((line) => !isGoogleMeetBoilerplate(line));

  const compact = lines
    .join('\n')
    .replace(/\n[ \t]*\n(?:[ \t]*\n)+/g, '\n\n')
    .trim();
  return compact || null;
}
